import { render, staticRenderFns } from "./UpdatePassWord.vue?vue&type=template&id=6b6ad138&scoped=true&"
import script from "./UpdatePassWord.vue?vue&type=script&lang=js&"
export * from "./UpdatePassWord.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePassWord.vue?vue&type=style&index=0&id=6b6ad138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ad138",
  null
  
)

export default component.exports